/* eslint-disable @typescript-eslint/no-var-requires */
export const dynamicMediaByDacId = require('./lib/dynamicMediaByDacId.graphql');
export const dcaDynamicContent = require('./lib/dcaDynamicContent.graphql');
export const dcaDynamicContentV2 = require('./lib/dcaDynamicContentV2.graphql');
export const dcaGrtDynamicContentV2 = require('./lib/dcaGrtDynamicContentV2.graphql');
